/** 评估项目流程跟踪 */
<template>
  <div class="patent">
    <TableList
      :table-data="tableData"
      :label-data="tableLabel"
      :loading="loading"
      :page="currentPage"
      :page-total="pagesNum"
      @changePage="changePage"
    >
      <template v-slot:btns>
        <el-button type="primary" plain round @click="$router.back()"> 返回项目列表 </el-button>
      </template>
      <template v-slot:description="{ scope }">
        <p>{{ scope.row.description }}</p>
        <el-link
          v-if="scope.row.value"
          type="primary"
          target="_bank"
          :href="$img_url + scope.row.value"
        >
          查看资料
        </el-link>
      </template>
      <template v-slot:refuse_text="{ scope }">
        <p>{{ scope.row.refuse_text }}</p>
        <el-link
          v-if="scope.row.refuse_file"
          type="primary"
          target="_bank"
          :href="$img_url + scope.row.refuse_file"
        >
          查看文件
        </el-link>
      </template>
    </TableList>
  </div>
</template>

<script>
import * as assessApi from "@/api/assessment.js";

import Search from "@/components/Search";
import TableList from "@/components/TableList";
export default {
  name: "Patent",
  components: {
    Search,
    TableList
  },
  data() {
    return {
      input: "",
      tableData: [],
      tableLabel: [
        { label: "创建时间", value: "created_at" },
        { label: "项目流程", value: "reason" },
        { label: "流程内容", value: "description", isSlot: true },
        { label: "审核建议", value: "refuse_text", isSlot: true },
        { label: "更新时间", value: "updated_at" },
        { label: "审核结果", value: "state_text" }
      ],
      currentPage: 1,
      pagesNum: null,
      loading: true,

      state_options: [
        { label: "待审核", value: 1 },
        { label: "通过", value: 2 },
        { label: "未通过", value: 3 }
      ]
    };
  },
  computed: {
    projectId() {
      return this.$route.query.projectId;
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getHistoryList();
  },
  methods: {
    async getHistoryList(page = 1) {
      this.loading = true;
      try {
        const { data } = await assessApi.getHistoryList({
          page,
          projectId: this.projectId
        });
        this.tableData = data.data.map(v => {
          v["state_text"] = this.state_options.find(i => i.value == v["state"]).label;
          return v;
        });
        this.currentPage = page;
        this.pageTotal = data.total;
      } catch (error) {}
      this.loading = false;
    },

    // 分页
    async changePage(page) {
      this.getPatentList(page);
    }
  }
};
</script>

<style scoped lang="less"></style>
